import type { CSSProperties } from 'react'
import clsx from 'clsx'
import { create } from '@bufbuild/protobuf'

import { PhotoRefSchema } from '@jotta/grpc-connect-openapi/photo'

import { usePhotoRef } from '../../api/usePhoto'
import type { MediaThumbProps } from '../PhotoGallery/MediaThumb'
import { MediaThumb } from '../PhotoGallery/MediaThumb'

import styles from './PhotoSearch.module.scss'

export function PhotoSearchThumb({
  onNavigate,
  border = false,
  debugInfo,
  width,
  height,
  md5,
  ...props
}: {
  onNavigate?: (id: string) => void
  border?: boolean
  width: number
  height: number
  md5: string
  debugInfo?: { [key: string]: string | number | boolean }
} & Omit<MediaThumbProps, 'showSimilarSearch' | 'title' | 'photo'>) {
  const { data: photo } = usePhotoRef(
    create(PhotoRefSchema, {
      ref: {
        case: 'md5',
        value: md5,
      },
    }),
  )

  const title = debugInfo
    ? Object.entries(debugInfo)
        .map(([key, val]) => `${key}=${JSON.stringify(val)}`)
        .join('\n')
    : ''

  if (!photo) {
    return undefined
  }

  return (
    <div
      style={{ '--aspect-ratio': width / height } as CSSProperties}
      className={clsx(styles.thumbListThumb, { [styles.border]: border })}
    >
      <MediaThumb
        {...props}
        photo={photo}
        title={title}
        showSimilarSearch
        onNavigate={onNavigate}
      />
    </div>
  )
}
